import { render, staticRenderFns } from "./TopPick.vue?vue&type=template&id=20974eb1&scoped=true&"
import script from "./TopPick.vue?vue&type=script&lang=js&"
export * from "./TopPick.vue?vue&type=script&lang=js&"
import style0 from "./TopPick.vue?vue&type=style&index=0&id=20974eb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20974eb1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TacoRating: require('/app/appsumo/nuxt/components/TacoRating.vue').default,DealPrice: require('/app/appsumo/nuxt/components/common/DealPrice.vue').default,DealImpression: require('/app/appsumo/nuxt/components/common/DealImpression.vue').default})
